import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Typography, Box, CircularProgress } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

const EmailConfirmationButtons = ({ sendEmail, isEmailEnabled }) => {
  const [step, setStep] = useState('initial');

  const handleSendClick = () => {
    setStep('confirmation');
  };

  const handleConfirmClick = async () => {
    setStep('loading');
    try {
      const response = await sendEmail();
      if (response.status === 200) {
        setStep('success');
      } else {
        setStep('error');
      }
    } catch (error) {
      setStep('error');
    }
    setTimeout(() => {
      setStep('initial');
    }, 5000); // 5 segundos antes de volver al estado inicial
  };

  const handleCancelClick = () => {
    setStep('initial');
  };

  return (
    <Box sx={{ mt: 3, width: '100%' }}>
      {step === 'initial' && (
        <Button
          variant="contained"
          color="primary"
          startIcon={<MailOutlineIcon />}
          onClick={handleSendClick}
          disabled={!isEmailEnabled}
          sx={{ width: '100%' }}
        >
          Enviar Correo
        </Button>
      )}

      {step === 'confirmation' && (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography variant="h6" gutterBottom>
            ¿Estás seguro que quieres enviar el correo?
          </Typography>
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleConfirmClick}
              sx={{ mr: 2, width: '40%' }}
            >
              Sí
            </Button>
            <Button variant="outlined" sx={{ width: '40%' }} onClick={handleCancelClick}>
              No
            </Button>
          </Box>
        </Box>
      )}

      {step === 'loading' && (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: '50px',
          }}
        >
          <CircularProgress color="secondary" />
        </Box>
      )}
      {step === 'success' && (
        <Button sx={{ width: '100%' }} variant="contained" color="success">
          Envío exitoso
        </Button>
      )}

      {step === 'error' && (
        <Button sx={{ width: '100%' }} variant="contained" color="error">
          Ha ocurrido un error, intente nuevamente
        </Button>
      )}
    </Box>
  );
};

EmailConfirmationButtons.propTypes = {
  sendEmail: PropTypes.func.isRequired,
  isEmailEnabled: PropTypes.bool.isRequired,
};
export default EmailConfirmationButtons;
